import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.sortOrder;

export const sortOrderSelectors = {
  sortOrders: createSelector(selector, (state) => state.sortOrders),
};
